const LOCATIONS = {
  GLEAM_TOWN: "Gleam Town",
  GLIMMER_PLAINS: "Glimmer Plains",
  SHADE_CAVE: "Shade Cave",
}

export default LOCATIONS;